export function FilterDistinctByIdAndSort(array: any): any {
  const uniqueIds = new Set<string>();
  const result: any = [];

  for (const obj of array) {
      if (!uniqueIds.has(obj.value)) {
          uniqueIds.add(obj.value);
          result.push(obj);
      }
  }

  // Sort the result array based on the 'value' property
  result.sort((a, b) => (
      // Assuming 'value' is a string, modify this comparison accordingly
      a.value.localeCompare(b.value)
  ));

  return result;
}